var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.508,
    height: 22,
    viewBox: "0 0 34.508 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "car",
    transform: "translate(-6.893 -18.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34323",
    "data-name": "Path 34323",
    d: "M57.919,41.748a2.4,2.4,0,1,1,2.4-2.4A2.4,2.4,0,0,1,57.919,41.748Zm0-3.761a1.36,1.36,0,1,0,1.359,1.36A1.36,1.36,0,0,0,57.919,37.987Z",
    transform: "translate(-23.283 -8.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34324",
    "data-name": "Path 34324",
    d: "M17.7,41.748a2.4,2.4,0,1,1,2.4-2.4,2.4,2.4,0,0,1-2.4,2.4Zm0-3.761a1.36,1.36,0,1,0,1.36,1.36,1.36,1.36,0,0,0-1.36-1.36Z",
    transform: "translate(-4.025 -8.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34325",
    "data-name": "Path 34325",
    d: "M40.242,45.068H26.516a.521.521,0,0,1-.442-.8L27.6,41.806a.521.521,0,0,1,.443-.246H38.714a.521.521,0,0,1,.443.246l1.529,2.466a.521.521,0,0,1-.443.8Zm-12.79-1.042H39.305L38.423,42.6H28.334Z",
    transform: "translate(-9.147 -10.854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34326",
    "data-name": "Path 34326",
    d: "M40.1,50.964H23.386a.521.521,0,1,1,0-1.042H40.1a.521.521,0,1,1,0,1.042Z",
    transform: "translate(-7.648 -14.858)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34327",
    "data-name": "Path 34327",
    d: "M39.252,45.182H12.089a2.035,2.035,0,0,1-2.033-2.033V38.477A5.386,5.386,0,0,1,15.435,33.1H35.9a5.386,5.386,0,0,1,5.38,5.377v4.672a2.035,2.035,0,0,1-2.033,2.033ZM15.435,34.142A4.342,4.342,0,0,0,11.1,38.479v4.672a.99.99,0,0,0,.99.99H39.252a.99.99,0,0,0,.99-.99V38.477A4.342,4.342,0,0,0,35.9,34.142Z",
    transform: "translate(-1.515 -6.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34328",
    "data-name": "Path 34328",
    d: "M59.769,57.839h-2.82a1.168,1.168,0,0,1-1.167-1.167V54.8a.521.521,0,0,1,.521-.521h4.111a.521.521,0,0,1,.521.521v1.868a1.168,1.168,0,0,1-1.167,1.167Zm-2.945-2.514v1.347a.125.125,0,0,0,.125.125h2.82a.125.125,0,0,0,.125-.125V55.325Z",
    transform: "translate(-23.41 -16.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34329",
    "data-name": "Path 34329",
    d: "M18.348,57.839h-2.82a1.168,1.168,0,0,1-1.167-1.167V54.8a.521.521,0,0,1,.521-.521h4.111a.521.521,0,0,1,.521.521v1.868A1.168,1.168,0,0,1,18.348,57.839ZM15.4,55.325v1.347a.125.125,0,0,0,.125.125h2.82a.124.124,0,0,0,.124-.125V55.325Z",
    transform: "translate(-3.576 -16.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34330",
    "data-name": "Path 34330",
    d: "M40.538,27.8a.521.521,0,0,1-.479-.313l-2.73-6.3a2.806,2.806,0,0,0-2.345-1.257H21.47a2.809,2.809,0,0,0-2.345,1.257l-2.731,6.3a.521.521,0,1,1-.956-.414l2.747-6.337a.591.591,0,0,1,.041-.076,3.849,3.849,0,0,1,3.246-1.767H34.982a3.847,3.847,0,0,1,3.245,1.768.5.5,0,0,1,.041.076l2.748,6.338a.521.521,0,0,1-.478.73Z",
    transform: "translate(-4.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34331",
    "data-name": "Path 34331",
    d: "M63.792,33.9H62.431a.521.521,0,1,1,0-1.042h1.361a.521.521,0,1,1,0,1.042Z",
    transform: "translate(-26.345 -6.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34332",
    "data-name": "Path 34332",
    d: "M68.247,31.786h-3.2a.521.521,0,0,1-.521-.521v-2.3a.521.521,0,0,1,.521-.521h2.542A1.413,1.413,0,0,1,69,29.851v1.186A.749.749,0,0,1,68.247,31.786Zm-2.683-1.042h2.389v-.892a.369.369,0,0,0-.369-.369H65.564Z",
    transform: "translate(-27.595 -4.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34333",
    "data-name": "Path 34333",
    d: "M15.36,33.9H14a.521.521,0,1,1,0-1.042H15.36a.521.521,0,1,1,0,1.042Z",
    transform: "translate(-3.153 -6.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34334",
    "data-name": "Path 34334",
    d: "M10.846,31.786h-3.2a.749.749,0,0,1-.749-.748V29.851A1.413,1.413,0,0,1,8.3,28.44h2.542a.521.521,0,0,1,.521.521v2.3A.521.521,0,0,1,10.846,31.786ZM7.935,30.744h2.389V29.482H8.3a.369.369,0,0,0-.369.369Z",
    transform: "translate(0 -4.572)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.891a85c7b9ed4538d53111d407572430.svg";
export { ForwardRef as ReactComponent };